/**
 * Shape of a Cloud Connector ID as issued by the SSM5 Cloud Connector application:
 * two groups of eight alphanumerics joined by a hyphen (`CD27D639-05FDAAB6`), optionally
 * followed by an `@` environment tag (`CD27D639-05FDAAB6@ph2_dev3_2.3.7`).
 */
const CLOUD_CONNECTOR_ID_PATTERN = /^[A-Z0-9]{8}-[A-Z0-9]{8}(@\S+)?$/i;

const ENVIRONMENT_TAG_SEPARATOR = '@';

/**
 * Check whether a value has the shape of a Cloud Connector ID. This is a format guard only;
 * whether the identifier exists or is still active is decided by the server.
 *
 * @param value - the raw Cloud Connector ID as entered or pasted
 * @returns true when the value matches the Cloud Connector ID shape
 */
export function isValidCloudConnectorId(value: string): boolean {
    return CLOUD_CONNECTOR_ID_PATTERN.test(value.trim());
}

/**
 * Trim surrounding whitespace and upper-case the identifier, leaving any environment tag as typed.
 *
 * @param value - the raw Cloud Connector ID as entered or pasted
 * @returns the normalized identifier
 */
export function normalizeCloudConnectorId(value: string): string {
    const trimmed = value.trim();
    const tagStart = trimmed.indexOf(ENVIRONMENT_TAG_SEPARATOR);

    if (tagStart < 0) {
        return trimmed.toUpperCase();
    }

    return trimmed.slice(0, tagStart).toUpperCase() + trimmed.slice(tagStart);
}
